import { showNotification } from 'swag-client-common/redux/notification/notification.actions';
import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { PRICE_BREAKS_POPUP } from 'swag-client-common/constants';
import { addAssociatedProduct } from '../product/product.actions';
import { handleGeneralQuantityChange, changeSingleQuantity, selectVariant, confirmSplitOrder, unselectColor, changeSizeIndex, init } from './related-product.actions';
export const detailsDispatcher = dispatch => ({
  onVariantChange: index => {
    dispatch(selectVariant(index));
  },
  onSizeIndexChange: index => {
    dispatch(changeSizeIndex(index));
  },
  addAssociatedProduct: message => {
    dispatch(addAssociatedProduct());
    dispatch(showNotification({
      text: message
    }));
  },
  init: () => {
    dispatch(init());
  }
});
const quantityBlockDispatcher = dispatch => ({
  onPriceBreakClick: () => {
    dispatch(showPopup({
      popup: PRICE_BREAKS_POPUP
    }));
  },
  onSingleQuantityChange: (value, variantIndex, sizeIndex) => {
    const quantity = parseInt(value || 0, 10) || 0;
    if (quantity.toString().length < 7) {
      dispatch(changeSingleQuantity(quantity, variantIndex, sizeIndex));
    }
  },
  onGeneralQuantityChange: value => {
    const quantity = parseInt(value || 0, 10) || 0;
    if (quantity.toString().length < 7) {
      dispatch(handleGeneralQuantityChange(quantity));
    }
  }
});
export const singleQuantityBlockDispatcher = quantityBlockDispatcher;
export const multipleQuantityBlockDispatcher = quantityBlockDispatcher;
export const chooseColorDispatcher = dispatch => ({
  onColorClick: (variantIndex, active) => {
    if (active) {
      return dispatch(unselectColor(variantIndex));
    }
    return dispatch(selectVariant(variantIndex));
  },
  onToggleSplitOrder: value => {
    dispatch(confirmSplitOrder(value));
  }
});